import React from 'react';
import { Tabs } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const CardTabs = ({ className, ...props }) => {
  return <Tabs {...props} type="card" className={cn(styles.root, className)} />;
};

CardTabs.TabPane = Tabs.TabPane;

export default CardTabs;
